import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '@/api/client';
import { Topbar } from '@/components/Topbar';
import { Icon } from '@/components/Icon';
import { fmtRelative } from '@/lib/format';
import { haptic } from '@/lib/telegram';
import type { Report } from '@/types/domain';

export function CampaignReportsPage(): JSX.Element {
  const { id } = useParams();
  const cid = Number(id);
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState<Report | null>(null);

  const generate = async () => {
    setBusy(true);
    haptic('success');
    const r = await api.generateReport(cid);
    setBusy(false);
    setLast(r);
  };

  return (
    <div className="space-y-8">
      <Topbar title="Отчёт" subtitle="xlsx с полной картиной" />

      <div className="space-y-4">
        <p className="text-sm text-ink-300">
          Соберём свежий xlsx по этой кампании: посевы, отправленные сообщения, входящие в ЛС/упоминания
          и список ответивших пользователей.
        </p>

        <button
          onClick={generate}
          disabled={busy}
          className="btn-primary w-full text-base"
          style={{ padding: '20px 28px', fontSize: '17px' }}
        >
          {busy
            ? <><span className="dot dot-pulse bg-white" /> Собираю отчёт…</>
            : <><Icon name="download" size={18} /> Сгенерировать отчёт</>}
        </button>

        {last && (
          <a
            href={`/api/reports/${last.id}/download`}
            onClick={() => haptic('light')}
            className="card flex items-center gap-3 p-4 transition active:scale-[0.99]"
          >
            <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-grad-primary text-white">
              <Icon name="download" size={20} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-ink-50">{last.filePath.split('/').pop()}</div>
              <div className="text-2xs text-ink-500">Готов · {fmtRelative(last.generatedAt)}</div>
            </div>
            <span className="pill pill-good">скачать</span>
          </a>
        )}
      </div>
    </div>
  );
}
